import type { AccountSettingsForm } from './index.h'

/**
 * Check if username has meaningfully changed (non-empty after trim, different case-insensitively)
 */
export function hasUsernameChanged(current: string, initial: string): boolean {
  const trimmed = current.trim()
  const trimmedInitial = initial.trim()
  return (
    trimmed.length > 0 && trimmed.toLowerCase() !== trimmedInitial.toLowerCase()
  )
}

/**
 * Check if any password fields are filled
 */
export const shouldValidatePasswords = (form: AccountSettingsForm): boolean =>
  Boolean(form.currentPassword) ||
  Boolean(form.newPassword) ||
  Boolean(form.confirmPassword)
